import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PolicyQueryService {

  private policyQuerySource = new BehaviorSubject<any>(null);
  currentPolicyQuery = this.policyQuerySource.asObservable();

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) {}

  getPolicyQuery() {
    this.http.get<PolicyQueryData[]>(`${this.baseUrl}api/policyquery/currentuserendpoints`).subscribe(
      response => {
        if (response) {
          let responseObj: any = this.arrayToObject(response);
          this.changePolicyQuery(responseObj);
          console.log('policyquery called with response');
        } else {
          this.changePolicyQuery(null);
          console.log('policyquery called no response');
        }
      },
      error => {
        console.error(error)
      }
    );
  }

  arrayToObject = (array: any[]) =>
    array.reduce((obj, item) => {
      obj[item.attributeRouteTemplate] = item;
      return obj
    }, {})

  changePolicyQuery(policyQuery: any) {
    this.policyQuerySource.next(policyQuery);
  }

}

export interface PolicyQueryData {
  actionName: string,
  attributeRouteTemplate: string,
  canAccess: boolean,
  controllerName: string,
  description: string,
  httpMethods: any[],
  parameters: any[]
}